import React from "react";
import { languages } from "../../../constants/languages";
import { withTheme } from "@material-ui/core/styles";
import Tooltip from "@material-ui/core/Tooltip";
import IconButton from "@material-ui/core/IconButton";
import Icon from "@mdi/react";
import { mdiMedal } from "@mdi/js";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";

class PlayerStatsContainer extends React.Component {
  state = {
    anchorEl: null,
  };

  openMenu = (event) => {
    this.setState({ anchorEl: event.currentTarget });
  };

  closeMenu = () => {
    this.setState({ anchorEl: null });
  };

  handleSubmit = (e, divisionId, statKey) => {
    e.preventDefault();

    let numInDia = 0;
    if (this.props.structureElements.length > 0) {
      let lastElement =
        this.props.structureElements[
          this.props.structureElements.length - 1
        ] || {};
      numInDia =
        lastElement[
          lastElement.numInDiaLocal !== undefined
            ? "numInDiaLocal"
            : "numInDia"
        ] + 1;
    }

    let toUpdate = {};
    toUpdate["diaPlayerStatsIndex" + divisionId + "_" + statKey] = numInDia;

    window.firebase
      .firestore()
      .collection("tournaments")
      .doc(this.props.tournament[".key"])
      .collection("dias")
      .doc(this.props.dia.id)
      .update(toUpdate);
  };

  render() {
    const playerPoints = this.props.tournament.playerPoints || {};
    // Only statistics that count player values (skip "attendance" type "3"
    // which is more of a tracking field than a ranking-worthy stat).
    const statEntries = Object.keys(playerPoints)
      .map((key) => ({ key: key, ...playerPoints[key] }))
      .filter((p) => p.type !== "3");

    if (statEntries.length === 0) {
      return null;
    }

    let menuItems = [];
    statEntries.forEach((stat) => {
      this.props.divisions.forEach((division) => {
        const fieldName =
          "diaPlayerStatsIndex" + division.id + "_" + stat.key;
        const disabled =
          this.props.dia[fieldName] !== null &&
          this.props.dia[fieldName] !== undefined;

        const statLabel = stat.name || stat.abbr || "";
        const divisionSuffix =
          this.props.divisions.length > 1 ? " - " + division.name : "";

        menuItems.push(
          <MenuItem
            key={`${stat.key}_${division.id}`}
            style={{
              height: 30,
              padding: "0 40px 0 10px",
            }}
            onClick={(e) => {
              this.closeMenu();
              this.handleSubmit(e, division.id, stat.key);
            }}
            disabled={disabled}
          >
            {statLabel + divisionSuffix}
          </MenuItem>
        );
      });
    });

    return (
      <div style={{ display: "inline-block" }}>
        <Tooltip title={languages.results.playerStats}>
          <IconButton onClick={this.openMenu} size="small">
            <Icon
              path={mdiMedal}
              color="rgba(0, 0, 0, 0.54)"
              style={{ height: 20, width: 20 }}
            />
          </IconButton>
        </Tooltip>
        <Menu
          id="player-stats-menu"
          anchorEl={this.state.anchorEl}
          open={Boolean(this.state.anchorEl)}
          onClose={this.closeMenu}
          PaperProps={{
            style: {
              maxHeight: 30 * 8,
              minWidth: 220,
            },
          }}
        >
          {menuItems}
        </Menu>
      </div>
    );
  }
}

export default withTheme(PlayerStatsContainer);
